import React, { Component, useContext, useEffect } from "react";
import { contexData } from "@/store";
import { Checkbox, Input, Radio } from "antd";
import { language } from "@/utils/language";  
function AnswerValidityChren({
  children,
  colItem,
  onClick,
  onChange,
  ...other
}) {
  const { infoContex, dispatch } = useContext(contexData); //解构得到属性
  const onChange1 = (e) => {
    if (colItem.id == infoContex.highlight) {
      dispatch({ type: "highlight", data: { highlight: "" } });
    }
    onChange(e);
  };
  if (colItem.model == "matrix_input") {
    return <Input onChange={onChange1} {...other}  placeholder={language().input_placeholder} />;
  } else {
    return (
      <div
        onClick={() => {
          if (colItem.id == infoContex.highlight) {
            dispatch({ type: "highlight", data: { highlight: "" } });
          }
          onClick && onClick();
        }}
        {...other}
      >
        {children}
      </div>
    );
  }
}

export default AnswerValidityChren;
